import React from 'react';
import { ScrollArea } from '@/components/ui/scroll-area';
import { cn } from '@/lib/utils';

interface ResponsiveTableProps {
  children: React.ReactNode;
  className?: string;
}

export const ResponsiveTable: React.FC<ResponsiveTableProps> = ({ 
  children, 
  className 
}) => {
  return (
    <div className={cn("w-full", className)}>
      <ScrollArea className="w-full overflow-x-auto">
        <div className="min-w-full">
          {children}
        </div>
      </ScrollArea>
    </div>
  );
};